import { render } from "./ProfileInfo.vue?vue&type=template&id=5e275cc9&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"

import "./ProfileInfo.vue?vue&type=style&index=0&id=5e275cc9&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e275cc9"

export default script